const INITIAL_STATE = {
    patients: [], firebase:null, firebaseAuth:null
};

const userReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case 'LOGIN_USER_SUCCESS':
            return {
                ...state,
                patients: action.patients
            };
        case 'GET_FIREBASE REFERENCE':
            return{
              ...state,
              firebase:action.firebase,
              firebaseAuth: action.auth
            }

        default:
            return state;
    }
};


export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js